import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider as StoreProvider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { container } from './inversify.config';
import { Container } from 'inversify';
import { Provider } from 'inversify-react';
import { LocaleProvider } from 'antd';
import enGB from 'antd/lib/locale-provider/en_GB';

// Import parent components
import { MainController } from './app/main.controller';
import { LoginController } from './app/login/login.controller';

// Import private (secured) route attribute
import { PrivateRoute } from 'src/router';

// Initialize styles
require('./assets/scss/app.scss');
// Initialize routes

import configureStore from "./configure-store";

const store = configureStore();

// Define root component
class RootComponent extends React.Component<any, any> {
	private readonly container: Container;

	constructor(props: any, context: any) {
		super(props, context);
		this.container = container;
	}

	render() {
		return (
			<LocaleProvider locale={enGB}>
				<Provider container={this.container}>
					<StoreProvider store={store}>
						<Router>
							<Switch>
								<Route exact path="/login" component={LoginController} />
								<PrivateRoute path="/" component={MainController} />
							</Switch>
						</Router>
					</StoreProvider>
				</Provider>
			</LocaleProvider>
		);
	}
}

// Render component in DOM
ReactDOM.render(<RootComponent />, document.getElementById('content'));



// WEBPACK FOOTER //
// ./src/main.tsx